import clsx from "clsx";
import GroupIcon from "csi/middleware/icons/GroupIcon";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Button, FlexRowCenter, List, OverflowText, Text } from "src/designSystem/index";
import AttributeListItem from "./AttributeListItem";
import css from "./CustomViewAttributes.module.css";
import CustomViewAttributeGroup from "./CustomViewAttributeGroup";

interface AttributesGroupProps {
	/** attributes in group */
	group: CustomViewAttributeGroup;
}

const AttributesGroupHeader: FunctionComponent<AttributesGroupProps> = observer(function AttributesGroup({ group }) {
	const {
		canAddGroup,
		id,
		isAttributeGroup,
		name,
		onAddGroup,
	} = group;

	return (
		<FlexRowCenter
			className={clsx(css.group, isAttributeGroup && css.attributeGroup)}
			data-csi-attribute-group={id}
		>
			<GroupIcon />
			<OverflowText
				bold
				grow
				lineHeight={16}
				size={12}
				text={name}
				tooltipProps={{ placement: "top" }}
			/>
			{canAddGroup && (
				<Button
					className={clsx(css.groupAction, css.hoverButton)}
					onClick={onAddGroup}
				>
					<Text
						res="CustomViewAttributesAddGroup"
						semiBold
					/>
				</Button>
			)}
		</FlexRowCenter>
	);
});

const AttributesGroup: FunctionComponent<AttributesGroupProps> = observer(function AttributesGroup({ group }) {
	const {
		attributes,
		name,
	} = group;

	if (!attributes.length) {
		return null;
	}

	return (
		<>
			{!!name &&
				<AttributesGroupHeader group={group} />
			}
			<List>
				{attributes.map((attribute) => (
					<AttributeListItem
						attribute={attribute}
						// force new render when selected changes
						key={attribute.renderKey}
					/>
				))}
			</List>
		</>
	);
});

export default AttributesGroup;